import axios from "axios";
import { appConfig } from "../config/appConfig";

export async function getGeoJSONFromCoords(lat: number, lon: number) {
  const response = await axios.get(
    appConfig.geocoderUrl +
      `?lat=${lat}&lon=${lon}&addressonly=true&format=JSON`,
    {
      headers: {
        "x-api-key": `${appConfig.geocoderApiKey}`,
      },
    },
  );

  return response.data;
}
